// extracted by mini-css-extract-plugin
module.exports = {"stat":"_1mg7UMBp","icon":"_24ADx6x5"};